import './App.css';
import CircularGallery from './CircularGallery';
import Stack from './Stack';

function App() {
  const foodItems = [
    { image: '/food/bagel..jpg', text: 'Bagel' },
    { image: '/food/barbecue.jpg', text: 'Barbecue' },
    { image: '/food/a_emporter.jpg', text: 'À Emporter' },
    { image: '/food/pokebowl.jpg', text: 'Poke Bowl' },
    { image: '/food/ronde ou carré..jpg', text: 'Miam!' },
    { image: '/food/tarte kiwi abricot.jpg', text: 'Tarte Kiwi Abricot' },
    { image: '/food/tarte aux fraises.jpg', text: 'Tarte aux Fraises' },
    { image: '/food/pavlova.jpg', text: 'Pavlova' },
    { image: '/food/fromages.jpg', text: 'Fromages' },
    { image: '/food/cookies.jpg', text: 'Cookies' },
    { image: '/food/desserts.jpg', text: 'Desserts' }
  ];

  return (
    <div className="App">
      <header className="header">
        <div
          className="header-background"
          style={{backgroundImage: 'url(/banner.jpg)'}}
        ></div>
        <div className="header-content">
          <img src="/logo.png" alt="Le Café de Paris Logo" className="logo" />
          <h1>Le Café de Paris</h1>
          <p className="subtitle">Brasserie Conviviale à Monteux</p>
        </div>
      </header>

      <main className="main-content">
        <section className="intro-section">
          <h2>Bienvenue</h2>
          <p className="intro-text">
            Au cœur de Monteux, Le Café de Paris vous accueille dans une ambiance chaleureuse
            et conviviale. Venez partager des moments authentiques autour de nos plats variés
            et généreux.
          </p>
          <div style={{ height: '450px', position: 'relative' }}>
            <CircularGallery items={foodItems} bend={3} textColor="#592620" borderRadius={0.05} scrollEase={0.02}/>
          </div>
        </section>

        <section className="terrace-section">
          <h2>Notre Terrasse</h2>
          <p>
            Profitez de notre terrasse spacieuse, ombragée par des arbres parasols majestueux
            et une grande pergola élégante. Un havre de fraîcheur pour savourer nos plats et
            boissons en toute tranquillité.
          </p>
          <div style={{ height: '400px', position: 'relative', margin: '2rem 0' }}>
            <Stack
              randomRotation={true}
              sensitivity={180}
              sendToBackOnClick={false}
              cardDimensions={{ width: 300, height: 300 }}
              cardsData={[
                { id: 1, img: "/terrasse/1 (1).jpg" },
                { id: 2, img: "/terrasse/1 (2).jpg" },
                { id: 3, img: "/terrasse/1 (3).jpg" },
                { id: 4, img: "/terrasse/290915040_1091271958440816_3972140124571649731_n..jpg" },
                { id: 5, img: "/terrasse/290961478_418671130173261_5983858327630690148_n..jpg" },
                { id: 6, img: "/terrasse/291125616_178131384600381_8163711925816402469_n..jpg" }
              ]}
            />
          </div>
          <p className="highlight">
            Du déjeuner à l'afterwork, notre terrasse ombragée vous accueille pour des moments
            de détente et de convivialité.
          </p>
        </section>

        <section className="menu-section">
          <h2>Notre Carte</h2>
          <div className="menu-grid">
            <div className="menu-category">
              <h3>Nos Plats</h3>
              <ul>
                <li>Viandes</li>
                <li>Pizzas</li>
                <li>Salades composées</li>
                <li>Hamburgers</li>
                <li>Seiches à la plancha</li>
              </ul>
            </div>
            <div className="menu-category">
              <h3>Nos Boissons</h3>
              <ul>
                <li>Large choix de bières</li>
                <li>Large choix de vins</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h2>Informations Pratiques</h2>
          <div className="info-grid">
            <div className="info-card">
              <img src="/doodle-motif-634-signpost-direction-hover-pinch.png" alt="Adresse" className="info-icon" />
              <h3>Adresse</h3>
              <p>
                22 boulevard de Verdun<br />
                84170 Monteux
              </p>
            </div>
            <div className="info-card">
              <img src="/doodle-motif-246-earphone-telephone-hover-pinch.png" alt="Téléphone" className="info-icon" />
              <h3>Téléphone</h3>
              <p>
                <a href="tel:0490662089">04 90 66 20 89</a>
              </p>
            </div>
            <div className="info-card">
              <img src="/doodle-motif-292-clock-time-hover-pinch.png" alt="Horaires" className="info-icon" />
              <h3>Horaires</h3>
              <p>
                Ouvert tous les jours<br />
                de 6h à 21h
              </p>
            </div>
          </div>
          <p className="special-note">
            Lors des fêtes du village, notre brasserie est également ouverte le soir.
          </p>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <img src="/logo.png" alt="Le Café de Paris Logo" className="footer-logo" />
            <h3>Le Café de Paris</h3>
            <p>Brasserie Conviviale à Monteux</p>
          </div>

          <div className="footer-section">
            <h4>Actions</h4>
            <div className="footer-actions">
              <a href="tel:0490662089" className="footer-button">
                Réserver
              </a>
              <a href="#menu-section" className="footer-button" onClick={(e) => {
                e.preventDefault();
                document.querySelector('.menu-section').scrollIntoView({ behavior: 'smooth' });
              }}>
                Voir la Carte
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Suivez-nous</h4>
            <div className="social-links">
              <a
                href="https://www.facebook.com/cafedeparismonteux/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/cafedeparismonteux/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Le Café de Paris - Monteux</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
